export const getCountry = language => {
  const languageArray = language.split('-');
  const [languageCode, country] = languageArray;
  const hasOneItem = languageArray.length === 1;

  return hasOneItem ? languageCode.toUpperCase() : country;
};
